import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloudSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCloudSimple"><Path d="M17.25 19.5H8.85C4.79071 19.5 1.5 16.1421 1.5 12C1.5 7.85786 4.79071 4.5 8.85 4.5C11.8837 4.5 14.4881 6.37545 15.6105 9.05211C16.1263 8.87923 16.6775 8.78571 17.25 8.78571C20.1495 8.78571 22.5 11.1842 22.5 14.1429C22.5 17.1015 20.1495 19.5 17.25 19.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconCloudSimple;
